<!-- A szülő (Alkalmazottak) kártyáival egy vonalban: saját tárolóban, a külső margó nélkül. -->
<div class="tetel-panelek">
<div class="n-panel">
  <div class="alk-panel-fej"><div class="n-panel-cim">Állandó tételek</div>
    <button type="button" class="ov-gomb" (click)="ujAllando()"><ion-icon name="add"></ion-icon>Új tétel</button></div>
  <p class="halvany alk-sugo">Havonta ismétlődő jövedelem vagy levonás (pl. pótlék, szakszervezeti tagdíj) – az időszak minden hónapjában bekerül a számfejtésbe.</p>
  <table class="n-racs" *ngIf="allandok.length">
    <thead><tr><th>Jogcím</th><th>Összeg</th><th>Időszak</th><th></th></tr></thead>
    <tbody>
      <tr *ngFor="let a of allandok">
        <td><b>{{ a.kod }}</b> {{ a.jogcim }} <span class="cimke" [class.sarga]="a.tipus === 'levonas'" [class.zold]="a.tipus !== 'levonas'">{{ a.tipus === 'levonas' ? 'levonás' : 'jövedelem' }}</span>
          <div class="halvany" *ngIf="a.megjegyzes">{{ a.megjegyzes }}</div></td>
        <td>{{ osszegSzoveg(a.osszeg, a.szazalek, 'alapbér') }}</td>
        <td>{{ a.tol }} – {{ a.ig || '' }}</td>
        <td class="ber-muv"><button type="button" class="kv-mini" (click)="szerkAllando(a)"><ion-icon name="create-outline"></ion-icon></button>
          <button type="button" class="kv-torol" (click)="torol('/allando/' + a.id, a.jogcim)"><ion-icon name="trash-outline"></ion-icon></button></td>
      </tr>
    </tbody>
  </table>
  <p class="halvany" *ngIf="!allandok.length">Nincs állandó tétel.</p>
</div>

<div class="n-panel">
  <div class="alk-panel-fej"><div class="n-panel-cim">Nyugdíjpénztári tagság</div>
    <button type="button" class="ov-gomb" (click)="ujTagsag()"><ion-icon name="add"></ion-icon>Új tagság</button></div>
  <table class="n-racs" *ngIf="tagsagok.length">
    <thead><tr><th>Pénztár</th><th>Tagdíj</th><th>Munkáltatói hozzájárulás</th><th>Időszak</th><th></th></tr></thead>
    <tbody>
      <tr *ngFor="let t of tagsagok">
        <td><b>{{ t.penztar }}</b></td>
        <td>{{ osszegSzoveg(t.tagdij_osszeg, t.tagdij_szazalek, 'bruttó') }}</td>
        <td>{{ osszegSzoveg(t.munkaltatoi_osszeg, t.munkaltatoi_szazalek, 'bruttó') }}</td>
        <td>{{ t.tol }} – {{ t.ig || '' }}</td>
        <td class="ber-muv"><button type="button" class="kv-mini" (click)="szerkTagsag(t)"><ion-icon name="create-outline"></ion-icon></button>
          <button type="button" class="kv-torol" (click)="torol('/tagsag/' + t.id, t.penztar)"><ion-icon name="trash-outline"></ion-icon></button></td>
      </tr>
    </tbody>
  </table>
  <p class="halvany" *ngIf="!tagsagok.length">Nincs nyugdíjpénztári tagság.</p>
</div>
</div>

<ion-modal #allModal cssClass="ber-urlap-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Állandó tétel – {{ alkalmazott?.nev }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="allModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk-form" *ngIf="allSzerk">
        <label class="kv-mezo"><span>Jogcím *</span>
          <select [(ngModel)]="allSzerk.jogcim_id"><option *ngFor="let j of rogzithetoJogcimek" [ngValue]="j.id">{{ j.kod }} – {{ j.nev }}{{ j.tipus === 'levonas' ? ' (levonás)' : '' }}</option></select></label>
        <label class="kv-mezo"><span>Számítás</span>
          <select [(ngModel)]="allSzerk.mod"><option value="osszeg">Fix havi összeg</option><option value="szazalek">Az alapbér százaléka</option></select></label>
        <label class="kv-mezo" *ngIf="allSzerk.mod === 'osszeg'"><span>Összeg (Ft) *</span><input type="number" [(ngModel)]="allSzerk.osszeg"></label>
        <label class="kv-mezo" *ngIf="allSzerk.mod === 'szazalek'"><span>Százalék *</span><input type="number" step="0.01" [(ngModel)]="allSzerk.szazalek"></label>
        <label class="kv-mezo"><span>Kezdete *</span><input type="date" [(ngModel)]="allSzerk.tol"></label>
        <label class="kv-mezo"><span>Vége</span><input type="date" [(ngModel)]="allSzerk.ig"></label>
        <label class="kv-mezo"><span>Megjegyzés</span><input type="text" [(ngModel)]="allSzerk.megjegyzes"></label>
        <div class="nk-lab"><button type="button" class="ov-gomb fo" (click)="mentAllando()"><ion-icon name="save-outline"></ion-icon>Mentés</button></div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<ion-modal #nypModal cssClass="ber-urlap-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Nyugdíjpénztári tagság – {{ alkalmazott?.nev }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="nypModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk-form" *ngIf="nypSzerk">
        <label class="kv-mezo"><span>Pénztár *</span>
          <select [(ngModel)]="nypSzerk.penztar_id"><option *ngFor="let p of penztarak" [ngValue]="p.id">{{ p.nev }}</option></select></label>
        <p class="halvany" style="margin:0">Tagdíj és hozzájárulás: vagy a bruttó bér százaléka, vagy fix összeg (ha mindkettő meg van adva, a százalék érvényes).</p>
        <label class="kv-mezo"><span>Tagdíj (%)</span><input type="number" step="0.01" [(ngModel)]="nypSzerk.tagdij_szazalek"></label>
        <label class="kv-mezo"><span>Tagdíj (Ft)</span><input type="number" [(ngModel)]="nypSzerk.tagdij_osszeg"></label>
        <label class="kv-mezo"><span>Munkáltatói (%)</span><input type="number" step="0.01" [(ngModel)]="nypSzerk.munkaltatoi_szazalek"></label>
        <label class="kv-mezo"><span>Munkáltatói (Ft)</span><input type="number" [(ngModel)]="nypSzerk.munkaltatoi_osszeg"></label>
        <p class="halvany" style="margin:0;font-size:12px">A munkáltatói hozzájárulás bérként adózik (SZJA, TB-járulék, szocho), és a pénztárnak utalandó.</p>
        <label class="kv-mezo"><span>Kezdete *</span><input type="date" [(ngModel)]="nypSzerk.tol"></label>
        <label class="kv-mezo"><span>Vége</span><input type="date" [(ngModel)]="nypSzerk.ig"></label>
        <div class="nk-lab"><button type="button" class="ov-gomb fo" (click)="mentTagsag()"><ion-icon name="save-outline"></ion-icon>Mentés</button></div>
      </div>
    </div>
  </ng-template>
</ion-modal>
